import React, { useEffect, useState, useTransition } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import equityTab from "../../assets/images/svg/equityTab.svg";
import instrumentsEquity from "../../assets/images/svg/instrumentsEquity.svg";
//import ExtractButton from "../ExtractButton/ExtractButton";
import FilterButton from "../FilterButton/FilterButton";
import InternalTabs from "../InternalTabsPerf/InternalTabs";
import Modal from "../Modal";
import ModalFamily from "../ModalFamily/ModalFamily";
import PerformanceFilter from "../PerformanaceFilter/PerformanceFilter";
import PerformanaceValue from "../PerformanceValue/PerformanaceValue";
import unsortedIcon from "../../assets/images/png/upDown.png";
import sortedIcon from "../../assets/images/png/sortedIcon.png";
import sortedAtoz from "../../assets/images/png/descSortIcon.png";
import SelectNuvama from "../SelectNuvama/SelectNuvama";
//import PopupMenu from "../PopupMenu/PopupMenu";
import * as Scroll from "react-scroll";

import { observer } from "mobx-react-lite";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import downArrowBlack from "../../assets/images/svg/downArrowBlack.svg";
import {
  exportExcel,
  getCurrentDate,
  getLimitPer,
  getPrintDate,
  getSubAssetClasses,
  lakhAmt,
  numWithUnitPerformance,
  portfolioExcel,
  //printDocument,
  removeSymbol,
  setDerivativeTabKeys,
  assetClass,
  breadCrumbArray2,
  isValueExist,
  convertDateToObj,
  getAsOfDate,
  getDateFrmStr,
  isCustomDate,
  getEventDate,
  isFromGivenPage,
  getPerformance,
  downloadPDFFile,
} from "../../utils/functions";
//import PdfTable from "../PdfTable/PdfTable";
import EmptyPerformance from "../EmptyPerformance/EmptyPerformance";
import SearchButton2 from "../SearchButton2/SearchButton2";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import PerformanceStore from "../../store/PerformanceStore";
import { useRef } from "react";
import OverflowingText from "../OverflowingText/OverflowingText";
//import { useCallback } from "react";
import Header from "../Header/Header";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import { useLayoutEffect } from "react";
import { derivativeTabs } from "../../utils/data";
import {
  exportDataMenu,
  fromSnippetSub,
  showMeStocks,
} from "../../utils/constants";
import PageTitle from "../PageTitle/PageTitle";
import PageHeading from "../PageHeading/PageHeading";
import ExportReportList from "../AccessibleDropdown/ExportReportList";

const PerformanceLevel2 = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [selectedMember, setSelectedMember] = useState("0");
  //const [niftyMenu, setNiftyMenu] = useState(false);
  const [openFamilyModal, setOpenFamilyModal] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const { performanceRoute2, performanceRoute1, performanceRoute4 } =
    useParams();

  const routes = performanceRoute2?.split("_");
  const [locationArr, setLocationArr] = useState([]);
  const [vertualRows, setVertualRows] = useState([]);
  const [filteredColumn, setFilteredColumn] = useState("current_value");
  const [isAscendingForHeader, setIsAscendingForHeader] = useState(false);
  // const [transacSelec, setTransacSelec] = useState({});
  // const [optionSelec, setOptionSelec] = useState({});

  const [, startTransition] = useTransition();

  const [vertualRowsDer, setVertualRowsDer] = useState([]);
  const [vertualRowsDerSearch, setVertualRowsDerSearch] = useState([]);
  const [filteredColumnDer, setFilteredColumnDer] =
    useState("mtmgains_absolute");
  const [isAscendingForHeaderDer, setIsAscendingForHeaderDer] = useState(false);
  //const popuprefL2 = useRef(null);
  const itemRefs = useRef([]);

  const [timePeriod, setTimePeriod] = useState({
    value: "notSelected",
    isSelected: false,
  });

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);

  // const [localFilter, setLocalFilter] = useState({
  //   timePeriod: {
  //     value: "notSelected",
  //     title: "",
  //     isSelected: false,
  //   },
  //   transactionType: {
  //     value: "Both",
  //     id: 0,
  //   },
  //   optionType: {
  //     value: "Both",
  //     id: "B",
  //   },
  // });

  const location = useLocation();

  const performanceRef1 = useRef();

  const subAssetLevelId = "subAssetLevelId";
  const userHydrated = UserStore.isHydrated;
  const performanceHydrated = PerformanceStore.isHydrated;
  const secondPageData = PerformanceStore.secondPageNormalData;
  const tableLoader = PerformanceStore.inTableLoader;
  const assetClassDatas = PerformanceStore.assetClasses;

  const headerRenderer = ({ label, key, sortable, classn }) => {
    let currentSortKey = null;
    let currentSortingOrder = null;
    if (PerformanceStore.selectedAssetClass.id !== 6) {
      currentSortKey = filteredColumn;
      currentSortingOrder = isAscendingForHeader;
    } else {
      currentSortKey = filteredColumnDer;
      currentSortingOrder = isAscendingForHeaderDer;
    }

    return (
      <th
        key={key}
        aria-sort={
          currentSortKey === key
            ? currentSortingOrder
              ? "Ascending"
              : "Descending"
            : undefined
        }
        className={classn && classn}
      >
        {sortable ? (
          <div className="header_cell">
            <button
              className="label_wrapper header-button cursor blueTextColor"
              onClick={() => {
                if (PerformanceStore.selectedAssetClass.id !== 6)
                  sortable && handleSortForTransaction(key);
                else sortable && handleSortForDerivative(key);
              }}
            >
              <p>{label}</p>
              <div className="accordion_table_header_child_icon pointer">
                <img
                  aria-hidden={true}
                  src={
                    PerformanceStore.selectedAssetClass.id !== 6
                      ? isAscendingForHeader && filteredColumn === key
                        ? sortedIcon
                        : !isAscendingForHeader && filteredColumn === key
                          ? sortedAtoz
                          : filteredColumn !== key
                            ? unsortedIcon
                            : ""
                      : isAscendingForHeaderDer && filteredColumnDer === key
                        ? sortedIcon
                        : !isAscendingForHeaderDer && filteredColumnDer === key
                          ? sortedAtoz
                          : filteredColumnDer !== key
                            ? unsortedIcon
                            : ""
                  }
                  alt="sort"
                />
              </div>
            </button>
          </div>
        ) : (
          <div className="header_cell">
            <div
              className="label_wrapper blueTextColor"
              // onClick={() => {
              //   if (PerformanceStore.selectedAssetClass.id !== 6)
              //     sortable && handleSortForTransaction(key);
              //   else sortable && handleSortForDerivative(key);
              // }}
            >
              <p>{label}</p>
            </div>
          </div>
        )}
      </th>
    );
  };

  const redirectCellRenderer = (data, key) => {
    const redirect = () => {
      if (PerformanceStore.selectedAssetClass.id !== 6) {
        PerformanceStore.setInstrumentDetails([]);
      }
      PerformanceStore.setRef(data.instrument.id);
      UserStore.setNormalHybirdFlow(false);
      PerformanceStore.setThirdPageTitle(data?.instrument);
      PerformanceStore.setCurrentLoader("fullScreen");
      AuthStore.updateLoadingFullScreen(true);
      PerformanceStore.setIsClassIdChecked(false);
      PerformanceStore.setData(
        "persistedSecPageDuration",
        PerformanceStore.secPageSelectedDuration,
      );
      navigate(
        `/performance/${PerformanceStore.selectedAssetClass?.name.replaceAll(
          "/",
          ";",
        )} performance/${performanceRoute2}/${data?.instrument?.id}/${
          data?.instrument?.measureinstrumentid
        }`,
        {
          state: { from: "performance" },
        },
      );
    };
    return (
      <p>
        <button
          className="accordion_right_btn performance_btn_border_animation tableBtn buttonBlueBorder"
          onClick={redirect}
          aria-label={`View Instrument Details of Instrument ${data?.instrument?.name}`}
        >
          <svg
            width="8"
            height="12"
            viewBox="0 0 8 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.93394 5.64683L5.28634 6L4.93394 6.35317L0.706721 10.5896L1.41 11.2929L6.70289 6L1.41 0.707108L0.706722 1.41039L4.93394 5.64683Z"
              fill="white"
              stroke="#404040"
            />
          </svg>
        </button>
      </p>
    );
  };

  const investedValueCellRenderer = (data, key) => {
    switch (key) {
      case "instrument":
        return false ? (
          <p style={{ fontFamily: "Encode Sans" }}>{data?.[key]?.name}</p>
        ) : (
          <p>
            <OverflowingText
              ellipsisTextClassName={"tax_report_ins_name_class"}
              text={data?.[key]?.name}
              textClassName="performance_level2_ins_name"
              width={350}
            />
          </p>
        );
      case "current_value" || "Realised_gains":
        return (
          <p>
            <span className="red_text">
              {lakhAmt(data?.[key]?.actual_value) === "-0"
                ? "0"
                : numWithUnitPerformance(
                    data?.[key]?.value,
                    data?.[key]?.value_type,
                  )}
            </span>
          </p>
        );
      case "investmentPerformance":
        return (
          <p>
            <span className="red_text">
              {lakhAmt(data?.[key]?.return?.actual_value) === "-0"
                ? "0"
                : numWithUnitPerformance(
                    data?.[key]?.return?.value,
                    data?.[key]?.return?.value_type,
                  )}
            </span>
          </p>
        );
      case "xirr" || "MTM_gains":
        return (
          <p
            className={
              !data?.investmentPerformance?.xirr
                ? "dash"
                : data?.investmentPerformance?.xirr?.includes("-")
                  ? "red"
                  : "green"
            }
          >
            <span>
              {data?.investmentPerformance?.xirr
                ? getLimitPer(data?.investmentPerformance?.xirr) + "%"
                : "-"}
            </span>
          </p>
        );

      default:
        return <p className="invested_value_cell">{data[key]}</p>;
    }
  };

  const investedValueCellRenderer2 = (data, key) => {
    switch (key) {
      case "realised_amt_absolute":
        return (
          <p className="invested_value_cell">
            <span className={data?.[key]?.includes("-") ? "red" : "green"}>
              {numWithUnitPerformance(
                data?.realised_amt,
                data.realised_amt_type,
              )}
            </span>
          </p>
        );
      case "mtmgains_absolute":
        return (
          <p className="invested_value_cell">
            <span
              className={
                data?.[key] === "0.00" || (data?.mtmgains && isNaN(data?.[key]))
                  ? "dark"
                  : data?.[key]?.includes("-")
                    ? "red"
                    : "green"
              }
            >
              {data?.[key] === "0.00"
                ? "-"
                : numWithUnitPerformance(
                    data?.mtmgains,
                    data?.mtmgains_amt_type,
                  )}
            </span>
          </p>
        );
      case "instrumentname":
        return (
          <p style={{ paddingLeft: "20px" }} className="invested_value_cell">
            {data?.[key]}
          </p>
        );

      default:
        return <p className="invested_value_cell">{data[key]}</p>;
    }
  };

  const handleTabSelection = (data, index, allTabs) => {
    if (allTabs) {
      PerformanceStore.setRef("");
      PerformanceStore.setIsSecPageDataFetched(null);
      PerformanceStore.setCurrentLoader("inTableLoader");
      PerformanceStore.setPerformanceLoader("inTableLoader", true);

      if (PerformanceStore.selectedAssetClass.id !== 6) {
        setVertualRows([]);
        setFilteredColumn("current_value");
        setIsAscendingForHeader(false);
        PerformanceStore.setSecPageDuration(data);
      } else {
        setVertualRowsDer([]);
        setFilteredColumnDer("mtmgains_absolute");
        setIsAscendingForHeaderDer(false);
        PerformanceStore.setSecPageDuration(setDerivativeTabKeys(index));
      }
      if (PerformanceStore.selectedAssetClass.id !== 6) {
        const route = performanceRoute2?.split("_");
        PerformanceStore.onInternalTabChangesecondPageOrRedirect({
          assetClassId: route?.[0],
          subAssetClassId: route?.[1],
        });
      } else
        PerformanceStore.onInternalTabChangeSecPageDerivativeOrRedirect(
          // PerformanceStore.transacSelection,
          // PerformanceStore.optionSelection,
          PerformanceStore.rememberedTransactionSelection,
          PerformanceStore.rememberedOptionSelection,
          performanceRoute2,
          "tab selection",
        );
    } else if (data !== "CUSTOM") {
      PerformanceStore.setSecPageDuration(data);
    }
  };

  const equityLevel2Colums = [
    {
      label: "Instrument Name",
      key: "instrument",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
      cellRendererPdf: (data, row, key) => data?.name,
    },
    {
      label: "Current Value",
      key: "current_value",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
      cellRendererPdf: (data, row, key) => portfolioExcel(data?.actual_value),
      align: "right",
    },
    {
      label: "Absolute Return",
      key: "investmentPerformance",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
      cellRendererPdf: (data, row, key) =>
        portfolioExcel(data?.return?.actual_value),
    },
    {
      label: "IRR",
      labelPdf: "IRR(%)",
      key: "xirr",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
      cellRendererPdf: (data, row, key) =>
        row?.investmentPerformance?.xirr
          ? `${getLimitPer(row?.investmentPerformance?.xirr)}`
          : "-",
    },
    {
      label: "Action",
      key: "measureinstrumentid",
      sortable: false,
      cellRenderer: redirectCellRenderer,
    },
  ];

  const columnsDerivatives = [
    {
      label: "Instrument Name",
      key: "instrumentname",
      sortable: true,
      cellRenderer: investedValueCellRenderer2,
      cellRendererPdf: (data, row, key) => data,
      style: { width: "70%" },
    },
    {
      label: "Realised Gains",
      key: "realised_amt_absolute",
      sortable: true,
      cellRenderer: investedValueCellRenderer2,
      cellRendererPdf: (data, row, key) => (data ? portfolioExcel(data) : "-"),
      // width:''
    },
    {
      label: "MTM Gains",
      key: "mtmgains_absolute",
      sortable: true,
      cellRenderer: investedValueCellRenderer2,
      cellRendererPdf: (data, row, key) => (data ? portfolioExcel(data) : "-"),
    },
  ];

  const getPerformanceReportName = () => {
    return `Performance Report - ${
      PerformanceStore.famOrClient.name === "fam"
        ? UserStore.userData?.family_name
        : UserStore.userData?.full_name
    }`;
  };
  // const ExtractDataContent = () => {
  //   const exportExcelClick = () => {
  //     exportExcel({
  //       sheetname: `${
  //         PerformanceStore.selectedAssetClass?.id === 6
  //           ? PerformanceStore.futureOrOptions + " Performance"
  //           : `${removeSymbol(PerformanceStore.secondPageTitle)}`
  //       }`,
  //       columns:
  //         PerformanceStore.selectedAssetClass.id !== 6
  //           ? equityLevel2Colums
  //           : columnsDerivatives,
  //       data:
  //         PerformanceStore.selectedAssetClass?.id !== 6
  //           ? getFirstTimePdfData(
  //               PerformanceStore.secondPageRememberedNormalData,
  //               false,
  //               "normal",
  //               "current_value",
  //               "actual_value",
  //             )
  //           : getFirstTimePdfData(
  //               PerformanceStore.secondPageDerivativeRemberedData,
  //               false,
  //               "derivative",
  //               "mtmgains_absolute",
  //             ),

  //       reportDetails: {
  //         relatioshipManager: UserStore?.exportDetails?.find(
  //           (item) => item.role === "RM",
  //         )?.name,
  //         serviceManager: UserStore?.exportDetails?.find(
  //           (item) => item.role === "CXO",
  //         )?.name,
  //         date: getPrintDate(UserStore.asOfDate),
  //         clientName:
  //           UserStore.getData === "fam"
  //             ? UserStore.userData?.family_name
  //             : UserStore.userData?.full_name,
  //       },
  //       excelName: `${getPerformanceReportName()} - ${getCurrentDate()}`,
  //     });
  //   };

  //   const exportPdf = async () => {
  //     // printDocument(subAssetLevelId, {
  //     //   width: 950,
  //     //   height: 900,
  //     //   name: getPerformanceReportName(),
  //     // });

  //     if (isDownloading) return; // guard against double-click while already running
  //     setIsDownloading(true);
  //     try {
  //       await downloadPDFFile({
  //         headerName:
  //           PerformanceStore.selectedAssetClass?.id === 6
  //             ? PerformanceStore.futureOrOptions + " Performance"
  //             : `${removeSymbol(PerformanceStore.secondPageTitle)}`,
  //         fileId: subAssetLevelId,
  //         name: getPerformanceReportName(),
  //         columns:
  //           PerformanceStore.selectedAssetClass.id !== 6
  //             ? equityLevel2Colums
  //             : columnsDerivatives,

  //         data:
  //           PerformanceStore.selectedAssetClass?.id !== 6
  //             ? getFirstTimePdfData(
  //                 PerformanceStore.secondPageRememberedNormalData,
  //                 false,
  //                 "normal",
  //                 "current_value",
  //                 "actual_value",
  //               )
  //             : PerformanceStore.secondPageDerivativeRemberedData,
  //       });
  //     } finally {
  //       setIsDownloading(false);
  //       setNiftyMenu(false);
  //     }
  //   };
  //   return (
  //     <div className="extract_data_container downloadPdf">
  //       <p className="export_data_text">Export Data</p>
  //       <ul className="listitem_container">
  //         <li
  //           onClick={() => {
  //             exportExcelClick();
  //             setNiftyMenu(false);
  //           }}
  //         >
  //           <div className="listitem_icon excel"></div> Export to Excel
  //         </li>
  //         <li
  //           onClick={() => {
  //             exportPdf();
  //             // setNiftyMenu(false);
  //           }}
  //         >
  //           <div className="listitem_icon pdf"></div> Export to PDF
  //         </li>
  //       </ul>
  //       {isDownloading && (
  //         <div className="popup_downloader">
  //           <img src={loaderGIF} alt="img" />
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  const handleCheck = (checked) => {
    PerformanceStore.setRef("");
    if (PerformanceStore.selectedAssetClass.id === 6) {
      PerformanceStore.setShowHolding(
        PerformanceStore.showHoldingDerivatives === "1" ? "0" : "1",
      );
      PerformanceStore.setCurrentLoader("fullScreen");
      AuthStore.updateLoadingFullScreen(true);
      PerformanceStore.onInternalTabChangeSecPageDerivativeOrRedirect(
        // PerformanceStore.transacSelection,
        // PerformanceStore.optionSelection,
        PerformanceStore.rememberedTransactionSelection,
        PerformanceStore.rememberedOptionSelection,
        performanceRoute2,
        "checker",
      );
    } else {
      setIsChecked(!checked);
      PerformanceStore.setNonDerivativeCheckedStatus(checked);
    }
  };

  const mapLopp = (array) => {
    return array;
  };

  const mapDerivative = (array) => {
    if (!search) {
      return vertualRowsDer;
    } else {
      return vertualRowsDerSearch;
    }
  };

  const handleSortForTransaction = (filterType) => {
    PerformanceStore.setRef("");
    setFilteredColumn(filterType);
    setIsAscendingForHeader(!isAscendingForHeader);
  };

  const handleSortForDerivative = (filterType) => {
    setFilteredColumnDer(filterType);
    setIsAscendingForHeaderDer(!isAscendingForHeaderDer);
  };

  const handleWealth = () => {
    PerformanceStore.setLoaderClosingCheck({});
    PerformanceStore.setCurrentLoader("inTableLoader");
    PerformanceStore.setPerformanceLoader("inTableLoader", true);
    PerformanceStore.setSecPageDuration("ITD");
    PerformanceStore.setData("selectedEvent", {
      eventName: "Event not selected",
      id: null,
    });
    if (PerformanceStore.selectedAssetClass?.id !== 6) {
      const route = performanceRoute2?.split("_");
      PerformanceStore.onInternalTabChangesecondPageOrRedirect({
        assetClassId: route?.[0],
        subAssetClassId: route?.[1],
      });
    } else
      PerformanceStore.onInternalTabChangeSecPageDerivativeOrRedirect(
        // PerformanceStore.transacSelection,
        // PerformanceStore.optionSelection,
        PerformanceStore.rememberedTransactionSelection,
        PerformanceStore.rememberedOptionSelection,
        performanceRoute2,
        "handle wealth",
      );
    PerformanceStore.getPortAssetClasses();
    UserStore.getReportsPersistData();
    PerformanceStore.setPerformanceLastTabToInitial();
  };

  const setTransacSelection = (data) => {
    PerformanceStore.setFiltersSelection("transacSelection", data);
  };
  const setOptionSelection = (data) => {
    PerformanceStore.setFiltersSelection("optionSelection", data);
  };

  const getTitle = () => {
    return PerformanceStore.selectedAssetClass?.id === 6
      ? `${getPerformance({
          route: performanceRoute2,
        })}Performance`
      : // performanceRoute2 === "1"
        //   ? "Futures Performance"
        //   : "Options Performance"

        (PerformanceStore?.secPageReturnData?.instrumentVehicle?.name ||
          getSubAssetClasses(performanceRoute2?.split("_")?.[1])) +
          " Performance";
  };

  useLayoutEffect(() => {
    AuthStore.updateLoadingFullScreen(true);
  }, []);

  useEffect(() => {
    PerformanceStore.setSecPageDuration(
      isValueExist({
        value:
          PerformanceStore.selectedDuration ||
          PerformanceStore.persistedSecPageDuration,
        value2: PerformanceStore.secPageSelectedDuration,
        defaultValue: "ITD",
      }),
    );

    window.scrollTo(0, 0);

    return () => {
      PerformanceStore.setFiltersToInitialState();
      PerformanceStore.setDuration("");
      PerformanceStore.setData("filterData", {
        timePeriod: {
          value: "notSelected",
          isSelected: false,
        },
      });
    };
  }, []);

  const setNavigation = (newArr, newArr2) => {
    if (performanceRoute1 !== "derivatives") {
      setLocationArr(
        breadCrumbArray2(
          PerformanceStore.selectedAssetClass.id,
          newArr2,
          PerformanceStore?.secPageReturnData?.instrumentVehicle?.name ||
            getSubAssetClasses(routes?.[1] || ""),
          PerformanceStore?.instrumentDetails?.[0]?.instrument?.name,
          location.state?.from
            ? {
                ...location.state,
                assetClassId: location.state.assetClassId,
                section: location.state.parentSection,
                from: fromSnippetSub,
              }
            : "",
        ).slice(1),
      );
    } else {
      setLocationArr(
        breadCrumbArray2(
          PerformanceStore.selectedAssetClass.id,
          newArr,
          getPerformance({ route: performanceRoute2 }),
          //performanceRoute2 === "1" ? "Futures " : "Options "
        ).slice(1),
      );
    }
    if (performanceRoute4 !== undefined) {
      setLocationArr((prevState) => {
        prevState.pop();
        return prevState;
      });
    }
  };

  performanceRef1.current = setNavigation;

  useEffect(() => {
    const newArr = location.pathname.split("/");
    const newArr2 = [...newArr];
    performanceRef1.current(newArr, newArr2);
  }, [PerformanceStore.secPageReturnData]);

  useEffect(() => {
    if (PerformanceStore.isHydrated && UserStore.isHydrated) {
      const route = performanceRoute2?.split("_");

      const isFromHomeSnippet = isFromGivenPage({
        page: "home-snippet",
        location,
      });
      if (
        PerformanceStore.currentLoader !== "mainTabLoader" &&
        !PerformanceStore.mainTabLoader
      ) {
        // this will set the loader true
        PerformanceStore.setCurrentLoader("fullScreen");
        AuthStore.updateLoadingFullScreen(true);
      }
      if (isFromHomeSnippet) {
        // if user navigate here from home page
        // set selected duration and asset class
        // get duration from api and get rest of table data
        const [assetClassId, subAssetClassId] = route;
        PerformanceStore.getSubAssetDataOnSnippetNavigation({
          location,
          assetClassId,
          subAssetClassId,
        });
      } else if (!isFromHomeSnippet & !PerformanceStore.subTabs.length) {
        // if user is directly navigating from the url then it will get redirected to first page
        navigate("/performance/overall performace");
      } else if (
        performanceRoute1?.toLowerCase() === "derivatives" &&
        PerformanceStore.selectedAssetClass.id !== 6
      ) {
        // if route is for derivative and id is not of derivatives then we set asset class as derivative
        PerformanceStore.setAssetClassOnLinkClick({
          id: 6,
          name: "Derivatives",
        });
      } else if (
        performanceRoute1.toLocaleLowerCase() !== "derivatives" &&
        PerformanceStore.selectedAssetClass.id === 6
      ) {
        // if route is not for derivative and id is of derivatives then we set asset class as whatever id is coming

        PerformanceStore.setAssetClassOnLinkClick({
          id: !isNaN(route[0]) ? Number(route[0]) : route[0],
          name: assetClass[route[0]],
        });
      } else if (PerformanceStore.selectedAssetClass.id !== 6) {
        const tabs = PerformanceStore.subTabs;
        const duration = PerformanceStore.secPageSelectedDuration;
        const persistedDuration = PerformanceStore.persistedSecPageDuration;

        const getSubAssetData = () => {
          const route = performanceRoute2?.split("_");
          PerformanceStore.onInternalTabChangesecondPageOrRedirect({
            assetClassId: route?.[0],
            subAssetClassId: route?.[1],
          });
        };

        if (persistedDuration && !tabs?.includes(duration)) {
          // of selected duration is custom date either date or any event
          PerformanceStore.setData("lastTabName", persistedDuration);
          if (isCustomDate(duration)) {
            const dates = PerformanceStore.persistedSecPageDuration?.split("-");
            PerformanceStore.setData("fromDatePerf", getDateFrmStr(dates[0]));
            PerformanceStore.setData("toDatePerf", getDateFrmStr(dates[1]));
            getSubAssetData();
            // PerformanceStore.setData("persistedSecPageDuration", "");
          } else {
            PerformanceStore.getEvents(
              (data) => {
                const datesObj = data.find(
                  (event) =>
                    event.eventName ===
                    PerformanceStore.persistedSecPageDuration,
                );
                const fromDate = getEventDate(datesObj.fromDate);
                const toDate = getEventDate(datesObj.toDate);

                PerformanceStore.setData("fromDatePerf", fromDate);
                PerformanceStore.setData("toDatePerf", toDate);

                getSubAssetData();

                //PerformanceStore.setData("persistedSecPageDuration", "");
              },
              (err) => {},
            );
          }
        } else getSubAssetData();
      } else if (PerformanceStore.selectedAssetClass.id == 6) {
        PerformanceStore.onInternalTabChangeSecPageDerivativeOrRedirect(
          PerformanceStore.rememberedTransactionSelection,
          PerformanceStore.rememberedOptionSelection,
          // PerformanceStore.transacSelection,
          // PerformanceStore.optionSelection,
          performanceRoute2,
        );
      } else {
        AuthStore.updateLoadingFullScreen(false);
      }

      PerformanceStore.setIsClassIdChecked(true, "setting true");
      PerformanceStore.setPerformanceApiCalled(true);
    }
  }, [PerformanceStore.isHydrated, UserStore.isHydrated]);

  const getFirstTimePdfData = (data, isAscending, type, key, extraKey) => {
    if (type === "normal") {
      if (isAscending) {
        return [...data]?.sort(
          (a, b) =>
            Number(a?.current_value?.actual_value) -
            Number(b?.current_value?.actual_value),
        );
      } else {
        return [...data]
          ?.sort(
            (a, b) =>
              Number(a?.current_value?.actual_value) -
              Number(b?.current_value?.actual_value),
          )
          .reverse();
      }
    } else {
      if (isAscending) {
        return [...data]?.sort(
          (a, b) => Number(a?.mtmgains_absolute) - Number(b?.mtmgains_absolute),
        );
      } else {
        return [...data]
          ?.sort(
            (a, b) =>
              Number(a?.mtmgains_absolute) - Number(b?.mtmgains_absolute),
          )
          .reverse();
      }
    }
  };

  const handleFilterModal = () => {
    if (PerformanceStore.isFilterApplied) {
      PerformanceStore.setFiltersSelection(
        "transacSelection",
        PerformanceStore.rememberedTransactionSelection,
      );
      PerformanceStore.setFiltersSelection(
        "optionSelection",
        PerformanceStore.rememberedOptionSelection,
      );
    } else if (!PerformanceStore.isFilterApplied) {
      PerformanceStore.setFilterSelection("initialState");
    }
    if (
      //  PerformanceStore.isDateFilterApplied
      PerformanceStore.filterData.timePeriod.isSelected
    ) {
      PerformanceStore.setTimePeriod(
        { value: PerformanceStore.currentAppliedFilter, isSelected: true },
        "changeWholeValue",
      );
    } else if (
      // !PerformanceStore.isDateFilterApplied ||
      !PerformanceStore.filterData.timePeriod.isSelected
    ) {
      PerformanceStore.setTimePeriod(
        { value: "notSelected", isSelected: false },
        "changeWholeValue",
      );
    }
    // PerformanceStore.setFilterApplied(true);
    // setTransacSelec({});
    // setOptionSelec({});
    setOpenFilterModal(true);
  };

  useEffect(() => {
    if (UserStore.isHydrated && PerformanceStore.isHydrated) {
      if (PerformanceStore.nonDerivativeCheckedStatus) setIsChecked(false);
      else {
        setIsChecked(true);
      }
      if (!PerformanceStore.isSecondPagePresent) {
        PerformanceStore.setFiltersToInitialState();
        PerformanceStore.setIsSecpage(true);
      }
    }
  }, [userHydrated, performanceHydrated]);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.addEventListener("scroll", () => {
      if (document.documentElement.scrollTop === 0) {
        setVertualRows(PerformanceStore.secondPageNormalData?.slice(0, 200));
      }
      if (
        document.documentElement.scrollHeight -
          document.documentElement.scrollTop +
          document.documentElement.clientHeight <
          2000 &&
        PerformanceStore.secondPageNormalData?.length
      ) {
        if (vertualRows) {
          setVertualRows((prev) => {
            if (prev) {
              return [
                ...prev,
                ...PerformanceStore.secondPageNormalData?.slice(
                  prev?.length,
                  prev?.length + 200,
                ),
              ];
            }
          });
        }
      }
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.addEventListener("scroll", () => {
      if (document.documentElement.scrollTop === 0) {
        setVertualRowsDer(
          PerformanceStore.secondPageDerivativeData?.slice(0, 10),
        );
      }
      if (
        document.documentElement.scrollHeight -
          document.documentElement.scrollTop +
          document.documentElement.clientHeight <
          2000 &&
        PerformanceStore.secondPageDerivativeData?.length
      ) {
        if (vertualRows) {
          setVertualRowsDer((prev) => {
            if (prev) {
              return [
                ...prev,
                ...PerformanceStore.secondPageDerivativeData?.slice(
                  prev?.length,
                  prev?.length + 10,
                ),
              ];
            }
          });
        }
      }
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (PerformanceStore.secondPageNormalData) {
      const slicing = PerformanceStore.secondPageNormalData?.slice(0, 200);
      const set1 = new Set(slicing);
      const arr2 = [...set1];
      setVertualRows(arr2);
    }
  }, [secondPageData, tableLoader]);

  useEffect(() => {
    !search
      ? setVertualRowsDer(
          PerformanceStore.secondPageDerivativeData?.slice(0, 10),
        )
      : setVertualRowsDerSearch(
          PerformanceStore.secondPageDerivativeData?.slice(0, 10),
        );
    // eslint-disable-next-line
  }, [PerformanceStore.secondPageDerivativeData]);

  useEffect(() => {
    if (UserStore.isHydrated && PerformanceStore.isHydrated) {
      let mainData = PerformanceStore.secondPageRememberedNormalData;

      let rowData = mainData?.filter((data) => {
        if (isChecked && search.length !== 0) {
          return data?.instrument?.name
            ?.toLowerCase()
            ?.includes(search.toLowerCase());
        } else if (!isChecked && search.length === 0) {
          return data?.investmentPerformance?.withholdings;
        } else if (!isChecked && search.length !== 0) {
          return (
            data?.instrument?.name
              ?.toLowerCase()
              .includes(search.toLowerCase()) &&
            data?.investmentPerformance?.withholdings
          );
        } else {
          return data;
        }
      });

      if (rowData) {
        if (filteredColumn === "instrument" && !isAscendingForHeader) {
          PerformanceStore.updateSecondPageData(
            [...rowData]?.sort((a, b) =>
              b?.[filteredColumn]?.name.localeCompare(
                a?.[filteredColumn]?.name,
              ),
            ),
          );
        }
        if (filteredColumn === "instrument" && isAscendingForHeader) {
          PerformanceStore.updateSecondPageData(
            [...rowData]
              ?.sort((a, b) =>
                b?.[filteredColumn]?.name.localeCompare(
                  a?.[filteredColumn]?.name,
                ),
              )
              .reverse(),
          );
        }
        if (filteredColumn === "xirr" && isAscendingForHeader) {
          PerformanceStore.updateSecondPageData(
            [...rowData]?.sort(
              (a, b) =>
                Number(a?.investmentPerformance?.xirr) -
                Number(b?.investmentPerformance?.xirr),
            ),
          );
        }
        if (filteredColumn === "xirr" && !isAscendingForHeader) {
          PerformanceStore.updateSecondPageData(
            [...rowData]
              ?.sort(
                (a, b) =>
                  Number(a?.investmentPerformance?.xirr) -
                  Number(b?.investmentPerformance?.xirr),
              )
              .reverse(),
          );
        }

        if (
          filteredColumn === "investmentPerformance" &&
          isAscendingForHeader
        ) {
          PerformanceStore.updateSecondPageData(
            [...rowData]?.sort(
              (a, b) =>
                Number(a?.[filteredColumn]?.return?.actual_value) -
                Number(b?.[filteredColumn]?.return?.actual_value),
            ),
          );
        }
        if (
          filteredColumn === "investmentPerformance" &&
          !isAscendingForHeader
        ) {
          PerformanceStore.updateSecondPageData(
            [...rowData]
              ?.sort(
                (a, b) =>
                  Number(a?.[filteredColumn]?.return?.actual_value) -
                  Number(b?.[filteredColumn]?.return?.actual_value),
              )
              .reverse(),
          );
        }
        if (filteredColumn === "current_value" && isAscendingForHeader) {
          PerformanceStore.updateSecondPageData(
            [...rowData]?.sort(
              (a, b) =>
                Number(a?.[filteredColumn]?.actual_value) -
                Number(b?.[filteredColumn]?.actual_value),
            ),
          );
        }
        if (filteredColumn === "current_value" && !isAscendingForHeader) {
          PerformanceStore.updateSecondPageData(
            [...rowData]
              ?.sort(
                (a, b) =>
                  Number(a?.[filteredColumn]?.actual_value) -
                  Number(b?.[filteredColumn]?.actual_value),
              )
              .reverse(),
          );
        }
      }
    }
  }, [
    filteredColumn,
    isAscendingForHeader,
    search,
    isChecked,
    tableLoader,
    userHydrated,
    performanceHydrated,
    PerformanceStore.secondPageRememberedNormalData,
  ]);

  useEffect(() => {
    let mainData = PerformanceStore.secondPageDerivativeRemberedData;
    let rowData = mainData?.filter((data) => {
      if (!search) return true;
      else
        return data.instrumentname
          ?.toLowerCase()
          ?.includes(search?.toLowerCase());
    });

    if (rowData) {
      if (filteredColumnDer === "instrumentname" && !isAscendingForHeaderDer) {
        PerformanceStore.updateSecPageDerivativeData(
          [...rowData]?.sort((a, b) =>
            b?.[filteredColumnDer]?.localeCompare(a?.[filteredColumnDer]),
          ),
        );
      }
      if (filteredColumnDer === "instrumentname" && isAscendingForHeaderDer) {
        PerformanceStore.updateSecPageDerivativeData(
          [...rowData]
            ?.sort((a, b) =>
              b?.[filteredColumnDer]?.localeCompare(a?.[filteredColumnDer]),
            )
            .reverse(),
        );
      }
      if (
        filteredColumnDer === "realised_amt_absolute" &&
        isAscendingForHeaderDer
      ) {
        PerformanceStore.updateSecPageDerivativeData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumnDer]) - Number(b?.[filteredColumnDer]),
          ),
          "fromsecond",
        );
      }
      if (
        filteredColumnDer === "realised_amt_absolute" &&
        !isAscendingForHeaderDer
      ) {
        PerformanceStore.updateSecPageDerivativeData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumnDer]) - Number(b?.[filteredColumnDer]),
            )
            .reverse(),
        );
      }

      if (
        filteredColumnDer === "mtmgains_absolute" &&
        isAscendingForHeaderDer
      ) {
        PerformanceStore.updateSecPageDerivativeData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumnDer]) - Number(b?.[filteredColumnDer]),
          ),
        );
      }
      if (
        filteredColumnDer === "mtmgains_absolute" &&
        !isAscendingForHeaderDer
      ) {
        PerformanceStore.updateSecPageDerivativeData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumnDer]) - Number(b?.[filteredColumnDer]),
            )
            .reverse(),
          "fromsecond",
        );
      }
    }
  }, [filteredColumnDer, isAscendingForHeaderDer, search]);

  useEffect(() => {
    if (
      !AuthStore.isLoadingFullScreen &&
      UserStore.isHydrated &&
      PerformanceStore.isHydrated
    ) {
      setTimeout(() => {
        const itemToScroll = document.getElementById(
          `${PerformanceStore.selectedRefs}`,
        );

        itemToScroll &&
          Scroll.animateScroll.scrollTo(
            itemToScroll.getBoundingClientRect().top - 100,
            {
              offset: -200,
              isDynamic: true,
              duration: 3000,
              smooth: true,
              delay: 100,
            },
          );

        itemToScroll && PerformanceStore.setRef("");

        // }
      }, 200);
    }
  }, [userHydrated, performanceHydrated, secondPageData]);

  // const onClickOutside = useCallback(() => {
  //   setNiftyMenu(false);
  // }, []);
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (popuprefL2.current && !popuprefL2.current.contains(event.target)) {
  //       onClickOutside && onClickOutside();
  //     }
  //   };
  //   document.addEventListener("click", handleClickOutside, true);
  //   return () => {
  //     document.removeEventListener("click", handleClickOutside, true);
  //   };
  // }, [onClickOutside]);

  useEffect(() => {
    if (UserStore.isHydrated && PerformanceStore.isHydrated) {
      const idToCheck = !isNaN(PerformanceStore.selectedAssetClass.id)
        ? Number(PerformanceStore.selectedAssetClass.id)
        : PerformanceStore.selectedAssetClass.id;
      const assetClasses = PerformanceStore.assetClasses;
      if (assetClasses) {
        const data = assetClasses?.find(
          (eachData) => eachData.id === idToCheck,
        );
        if (!data) PerformanceStore.setIsSelectedIdPresent(false);
      }
    }
  }, [assetClassDatas, UserStore.isHydrated, PerformanceStore.isHydrated]);

  useEffect(() => {
    if (
      UserStore.isHydrated &&
      PerformanceStore.isHydrated &&
      (vertualRows.length ||
        (!vertualRows.length &&
          PerformanceStore.secondPageRememberedNormalData))
      // PerformanceStore.secondPageNormalData
    ) {
      setLoading(false);
    }
  }, [UserStore.isHydrated, PerformanceStore.isHydrated, vertualRows]);

  useEffect(() => {
    // match
    if (UserStore.isHydrated) {
      const asOfDateObj = convertDateToObj(getAsOfDate(UserStore.asOfDate));
      PerformanceStore.setData(
        "fromDatePerf",
        PerformanceStore.fromDatePerf
          ? PerformanceStore.fromDatePerf
          : asOfDateObj,
      );
      PerformanceStore.setData(
        "toDatePerf",
        PerformanceStore.toDatePerf ? PerformanceStore.toDatePerf : asOfDateObj,
      );
    }
  }, [UserStore.isHydrated]);

  useEffect(() => {
    if (openFilterModal) {
      setTimePeriod({ value: "", isSelected: false });
    }
  }, [openFilterModal]);

  // const handleClickFun = (index) => {};

  return (
    <>
      <PageTitle title={location.state?.title || getTitle()} />
      {AuthStore.isLoadingFullScreen ||
      !PerformanceStore.isHydrated ||
      !UserStore.isHydrated ? (
        <LoadingScreen />
      ) : (
        <>
          <Header type="performance" />
          <div className="performance_sub_aaset">
            <div>
              <BreadCrumb
                locationArr={locationArr}
                // clickFunction={(index) => handleClickFun(index)}
                parentName={"performance"}
                location={location.state?.from || ""}
              />
            </div>
            <div className="performance_level">
              <div className="equity_title_div">
                <img src={equityTab} alt="" />
                <PageHeading
                  headingClass="pages_title wt700"
                  headingText={getTitle()}
                />
                <SelectNuvama
                  type={"onlybtn"}
                  handleWealth={(title) => handleWealth(title)}
                  handleClientSelection={() => handleWealth()}
                  setOpenFamilyModal={() => setOpenFamilyModal(true)}
                  selectedMember={selectedMember}
                  memberDropdownClass="analytics-members-dropdown"
                  memberDropdownTextClass="analytics-members-dropdown-text"
                  downArrowIcon={downArrowBlack}
                />
              </div>
              <div className="equity_tab_content">
                <InternalTabs
                  tabsDataProp={
                    PerformanceStore.selectedAssetClass.id !== 6
                      ? PerformanceStore.subTabs.concat([
                          PerformanceStore.lastTabName,
                        ])
                      : derivativeTabs
                    //    : derivativeTabs.concat([PerformanceStore.lastTabName])
                  }
                  setSelectedTab={(data, index, allTabs) =>
                    handleTabSelection(data, index, allTabs)
                  }
                  selectedTab={PerformanceStore.secPageSelectedDuration}
                  page="subAssetPage"
                  selectedIndex={selectedIndex}
                  setSelectedIndex={setSelectedIndex}
                />
                {PerformanceStore.inTableLoader ? (
                  <div
                    className="report_table_loader"
                    style={{ minHeight: "700px" }}
                  >
                    <div className="report_loader_wrapper add_margin40">
                      <img
                        style={{ marginBottom: "250px" }}
                        className="loading_gif"
                        src={loaderGIF}
                        alt="loading..."
                      />
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="equity_tab_content_container">
                      <div className="each_container_wrapper_level2">
                        <PerformanaceValue
                          revertStyle={
                            PerformanceStore.selectedAssetClass?.id !== 6
                              ? true
                              : false
                          }
                          data={
                            PerformanceStore.secPageReturnData?.absoluteReturn
                          }
                          derivative2={
                            PerformanceStore.derivativeInstrumentDetails?.[0]
                              ?.derivativeProfiles[0]
                          }
                        />
                      </div>
                    </div>
                    <div className="lackvalue"></div>
                    <div className="instru_wise_performance">
                      <img src={instrumentsEquity} alt="" />
                      <h2 className="section_heading">
                        Instrument Wise Performance
                      </h2>
                      <input
                        id="show-me-stocks"
                        className="input_checkbox cursor"
                        type="checkbox"
                        checked={
                          PerformanceStore.selectedAssetClass?.id !== 6
                            ? !isChecked
                            : PerformanceStore.showHoldingDerivatives === "1"
                        }
                        onChange={() => handleCheck(isChecked)}
                      />

                      <label
                        htmlFor="show-me-stocks"
                        className={`checkbox-label darkBlueTextColor ${
                          PerformanceStore.selectedAssetClass?.id !== 6 &&
                          isChecked
                            ? "unchecked_text cursor"
                            : PerformanceStore.selectedAssetClass?.id === 6 &&
                                PerformanceStore.showHoldingDerivatives === "0"
                              ? "unchecked_text cursor"
                              : "unchecked_text checked_text cursor"
                        }`}
                      >
                        {showMeStocks}
                      </label>

                      {/* <input
                        className="input_checkbox cursor"
                        type="checkbox"
                        checked={
                          PerformanceStore.selectedAssetClass?.id !== 6
                            ? !isChecked
                            : PerformanceStore.showHoldingDerivatives === "1"
                            ? true
                            : false
                        }
                        onChange={() => handleCheck(isChecked)}
                      />
                      <h3
                        className={
                          PerformanceStore.selectedAssetClass?.id !== 6 &&
                          isChecked
                            ? "unchecked_text cursor"
                            : PerformanceStore.selectedAssetClass?.id === 6 &&
                              PerformanceStore.showHoldingDerivatives === "0"
                            ? "unchecked_text cursor"
                            : "unchecked_text checked_text cursor"
                        }
                        onClick={() => handleCheck(isChecked)}
                      >
                        {showMeStocks}
                      </h3> */}
                      <div>
                        <SearchButton2
                          type={"search"}
                          search={search}
                          setSearch={(data) =>
                            startTransition(() => setSearch(data))
                          }
                          classes={"search_btn_out3"}
                          closeBtn={"big"}
                        />
                      </div>
                      {PerformanceStore.selectedAssetClass.id === 6 && (
                        <div className="filter_btn_wrapper">
                          <FilterButton onClick={handleFilterModal} />
                        </div>
                      )}
                      {/* <div ref={popuprefL2}>
                        <PopupMenu
                          setOpen={setNiftyMenu}
                          open={niftyMenu}
                          MenuContent={ExtractDataContent}
                        >
                          <ExtractButton />
                        </PopupMenu>
                      </div> */}
                      <ExportReportList
                        exportExcel={() => {
                          exportExcel({
                            sheetname: `${
                              PerformanceStore.selectedAssetClass?.id === 6
                                ? PerformanceStore.futureOrOptions +
                                  " Performance"
                                : `${removeSymbol(PerformanceStore.secondPageTitle)}`
                            }`,
                            columns:
                              PerformanceStore.selectedAssetClass.id !== 6
                                ? equityLevel2Colums
                                : columnsDerivatives,
                            data:
                              PerformanceStore.selectedAssetClass?.id !== 6
                                ? getFirstTimePdfData(
                                    PerformanceStore.secondPageRememberedNormalData,
                                    false,
                                    "normal",
                                    "current_value",
                                    "actual_value",
                                  )
                                : getFirstTimePdfData(
                                    PerformanceStore.secondPageDerivativeRemberedData,
                                    false,
                                    "derivative",
                                    "mtmgains_absolute",
                                  ),

                            reportDetails: {
                              relatioshipManager:
                                UserStore?.exportDetails?.find(
                                  (item) => item.role === "RM",
                                )?.name,
                              serviceManager: UserStore?.exportDetails?.find(
                                (item) => item.role === "CXO",
                              )?.name,
                              date: getPrintDate(UserStore.asOfDate),
                              clientName:
                                UserStore.getData === "fam"
                                  ? UserStore.userData?.family_name
                                  : UserStore.userData?.full_name,
                            },
                            excelName: `${getPerformanceReportName()} - ${getCurrentDate()}`,
                          });
                        }}
                        exportPdf={async () => {
                          // printDocument(subAssetLevelId, {
                          //   width: 950,
                          //   height: 900,
                          //   name: getPerformanceReportName(),
                          // });

                          if (isDownloading) return; // guard against double-click while already running
                          setIsDownloading(true);
                          try {
                            await downloadPDFFile({
                              headerName:
                                PerformanceStore.selectedAssetClass?.id === 6
                                  ? PerformanceStore.futureOrOptions +
                                    " Performance"
                                  : `${removeSymbol(PerformanceStore.secondPageTitle)}`,
                              fileId: subAssetLevelId,
                              name: getPerformanceReportName(),
                              columns:
                                PerformanceStore.selectedAssetClass.id !== 6
                                  ? equityLevel2Colums
                                  : columnsDerivatives,

                              data:
                                PerformanceStore.selectedAssetClass?.id !== 6
                                  ? getFirstTimePdfData(
                                      PerformanceStore.secondPageRememberedNormalData,
                                      false,
                                      "normal",
                                      "current_value",
                                      "actual_value",
                                    )
                                  : PerformanceStore.secondPageDerivativeRemberedData,
                            });
                          } finally {
                            setIsDownloading(false);
                            //setNiftyMenu(false);
                          }
                        }}
                        buttonProps={{
                          buttonType: "normalExport",
                          title: "Extract Data",
                        }}
                        popupClassName={{
                          open: "clicked-hover",
                          close: "",
                          wrapperClass: "popup_menu_container",
                          containerClass: "performance-extract downloadPdf",
                        }}
                        restrictHover={true}
                        itemRefs={itemRefs}
                        menuItems={exportDataMenu}
                        accessibilityValues={{
                          buttonId: "export-dropdown",
                          ariaHaspopup: "menu",
                          ariaControls: "extract-menu",
                          ariaLabel: "Extract Data",
                        }}
                      >
                        <>
                          {isDownloading && (
                            <div className="popup_downloader">
                              <img src={loaderGIF} alt="img" />
                            </div>
                          )}
                        </>
                      </ExportReportList>
                    </div>
                    <div className="performance_level2_table" id="tableId">
                      {PerformanceStore.selectedAssetClass.id !== 6 ? (
                        <table className="table performance_l2_table_container">
                          <thead>
                            <tr>{equityLevel2Colums?.map(headerRenderer)}</tr>
                          </thead>

                          {PerformanceStore.isHydrated &&
                          vertualRows &&
                          vertualRows.length !== 0 ? (
                            <tbody>
                              {mapLopp(vertualRows).length !== 0 ? (
                                vertualRows?.map((eachVehicle, index) => {
                                  return (
                                    <tr
                                      id={eachVehicle.instrument.id}
                                      // key={eachVehicle.instrument.id}
                                    >
                                      {equityLevel2Colums?.map((eachColumn) => {
                                        return (
                                          <td>
                                            {eachColumn?.cellRenderer
                                              ? eachColumn?.cellRenderer(
                                                  eachVehicle,
                                                  eachColumn.key,
                                                  equityLevel2Colums,
                                                )
                                              : JSON.stringify(
                                                  eachVehicle[eachColumn.key],
                                                )}
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td
                                    colSpan={5}
                                    style={{ borderBottom: "none" }}
                                  >
                                    {!loading && <EmptyPerformance />}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          ) : (
                            <tr>
                              <td colSpan={5} style={{ borderBottom: "none" }}>
                                {!loading && (
                                  <EmptyPerformance
                                    customClass={"no_data_border"}
                                  />
                                )}
                              </td>
                            </tr>
                          )}
                        </table>
                      ) : (
                        <table className="table accordion_content_derivatives_table">
                          <thead>
                            <tr>{columnsDerivatives?.map(headerRenderer)}</tr>
                          </thead>
                          {(PerformanceStore.isHydrated &&
                            vertualRowsDer &&
                            vertualRowsDer?.length !== 0) ||
                          (vertualRowsDerSearch &&
                            vertualRowsDerSearch?.length !== 0) ? (
                            <tbody>
                              {mapDerivative(vertualRowsDer)?.length !== 0 ? (
                                mapDerivative(vertualRowsDer)?.map(
                                  (eachVehicle) => {
                                    return (
                                      <tr>
                                        {columnsDerivatives.map(
                                          (eachColumn) => {
                                            return (
                                              <td>
                                                {eachColumn?.cellRenderer
                                                  ? eachColumn?.cellRenderer(
                                                      eachVehicle,
                                                      eachColumn.key,
                                                      PerformanceStore
                                                        .derivativeDetails[0]
                                                        ?.derivativeSubAssetClass_Details,
                                                    )
                                                  : JSON.stringify(
                                                      eachVehicle[
                                                        eachColumn.key
                                                      ],
                                                    )}
                                              </td>
                                            );
                                          },
                                        )}
                                      </tr>
                                    );
                                  },
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan={5}
                                    style={{ borderBottom: "none" }}
                                  >
                                    {" "}
                                    <EmptyPerformance />
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          ) : (
                            <tr>
                              <td colSpan={5} style={{ borderBottom: "none" }}>
                                <EmptyPerformance
                                  customClass={"no_data_border"}
                                />
                              </td>
                            </tr>
                          )}
                        </table>
                      )}
                    </div>
                  </>
                )}
              </div>
              {/* {
                <PdfTable
                  headerName={
                    PerformanceStore.selectedAssetClass?.id === 6
                      ? PerformanceStore.futureOrOptions + " Performance"
                      : `${removeSymbol(PerformanceStore.secondPageTitle)}`
                  }
                  columns={
                    PerformanceStore.selectedAssetClass.id !== 6
                      ? equityLevel2Colums
                      : columnsDerivatives
                  }
                  data={
                    PerformanceStore.selectedAssetClass?.id !== 6
                      ? getFirstTimePdfData(
                          PerformanceStore.secondPageRememberedNormalData,
                          false,
                          "normal",
                          "current_value",
                          "actual_value",
                        )
                      : PerformanceStore.secondPageDerivativeRemberedData
                  }
                  id={subAssetLevelId}
                />
              } */}
            </div>

            <Modal
              onClose={() => setOpenFamilyModal(false)}
              open={openFamilyModal}
              title={"Select Family Member"}
              width={"810px"}
            >
              <ModalFamily
                setSelectedMember={(id) => setSelectedMember(id)}
                selectedMember={selectedMember}
                onClose={() => setOpenFamilyModal(false)}
              />
            </Modal>
            <Modal
              onClose={() => setOpenFilterModal(false)}
              open={openFilterModal}
              title={"Filters"}
              width={"646px"}
              modalContainerClass="performance_filter_main"
              modalId={"date-picker-modal"}
            >
              <PerformanceFilter
                type={performanceRoute2}
                onClose={() => setOpenFilterModal(false)}
                timePeriod={timePeriod}
                setTimePeriod={setTimePeriod}
                // localTransac={{ selection: transacSelec, set: setTransacSelec }}
                // localOption={{
                //   selectionOption: optionSelec,
                //   setOption: setOptionSelec,
                // }}

                // filters={{ localFilter, setLocalFilter }}
                transacSelection={PerformanceStore.transacSelection}
                optionSelection={PerformanceStore.optionSelection}
                setTransacSelection={(data) => setTransacSelection(data)}
                setOptionSelection={(data) => setOptionSelection(data)}
                open={openFamilyModal}
              />
            </Modal>
          </div>
        </>
      )}
    </>
  );
};

export default observer(PerformanceLevel2);
